module.exports = __webpack_public_path__ + "img/edge-permit.fe93cd1.png";